import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => ({
  root: {
    width: "100%",
    padding: "1rem",
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));
